import React, {useState, useEffect, Fragment} from 'react';
import {connect} from "react-redux";
import {Spinner, Card} from "react-bootstrap";
import MapGeoJsonService from "../../services/MapGeoJsonService";

const HistoriqueListParcelles = (props) => {

    const mapGeoJsonService = new MapGeoJsonService();
    const [displayMe, setDisplayMe] = useState(true)
    const [title, setTitle] = useState('')

    useEffect((e)=>{

        if(props.histoParcelles && props.histoParcelles.length > 0){
            mapGeoJsonService.clearPropParcelleLayers();
            props.setDisplayHistoriqueList(true);
            addVisualParcelle(props.histoParcelles)
        }

    }, [props.histoParcelles])

    useEffect((e)=>{
       setTitle("Parcelles historiques")
    }, [])

    useEffect((encodeURIComponent =>{

        (!props.displayHistoriqueList)?mapGeoJsonService.clearPropParcelleLayers():null;

    }), [props.displayHistoriqueList])

    const renderItem = (item, index)=>{

        return (
            <tr key={index}>
                <td className={'text-center'}>
                    <button className={'btn btn-primary btn-sm text-white'} onClick={(e)=>{centerOnParcelle(item)}}>
                        <i className="fas fa-map-marker-alt"></i>
                    </button>
                </td>
                <td>{item.primitive}</td>
                <td>{item.parcelle_fille}</td>
                <td>{item.section}</td>
                <td>{item.numero_fille}</td>
                <td className={'d-none d-md-table-cell'}>{item.contenance} </td>
                <td className={'d-none d-md-table-cell'}>{item.date_mutation}</td>
                <td className={'d-none d-md-table-cell'}>{item.dnupro}</td>
                <td className={'d-none d-md-table-cell'}>{item.lieu}</td>
                <td className={'d-none d-md-table-cell'}>{item.commune}</td>
            </tr>
        )
    }

    const addVisualParcelle = (items)=>{

        let idParcelles = _.uniq(_.map(items,'parcelle_fille'));
        const url = "/Api/geodata/vmap/prop/parcelle/geom"
        const params = {
            "codes_com": idParcelles.toString()
        }

        if(idParcelles.length>0){
            axios.post(url, params)
                .then(result => {
                    (result.data && result.data.length > 0)
                        ? mapGeoJsonService.addPropParcellesLayer(props.refMap, result.data)
                        : null
                }).catch(err => {
                console.log(err)
            })
        }
    }

    const centerOnParcelle=(item)=>{
        mapGeoJsonService.centerOnGeom(item.geom_json)
    }

    const handleClosePanel=(e)=>{
        props.setDisplayHistoriqueList(false);
        props.cleanVectorLayer(false);
        props.setShowSearchPanel(false);
    }

    return (
        <Fragment>
            {(props.displayHistoriqueList)
                ?<div  className={'card ueThemeBackground'} style={{"width":"100%", "fontSize":"0.60rem", "marginLeft":"auto",  "marginRight":"auto","zIndex": "100","position":"absolute","bottom":"0px"}}>
                    <div className="card-body ueColorBase">
                        {(displayMe)
                            ?<Fragment>
                                <div className="d-flex justify-content-between mb-1">
                                    <div>
                                        <h5 className={"ueColorBase d-inline-flex mr-3"}>{title}</h5>
                                        <button className={'btn btn-primary btn-sm'} onClick={(e)=>setDisplayMe(false)}><i className="fas fa-caret-right"></i> Replier</button>
                                    </div>
                                    <div className={' border  p-1 pb-0 rounded rounded-2 align-self-end ueColorBase'}>
                                        {props.histoParcelles.length} enregistrement(s) retournés
                                    </div>
                                    <button className={'btn btn-primary btn-sm mb-1'} onClick={(e)=>handleClosePanel(e)}>Fermer</button>
                                </div>
                                <div style={{"maxHeight": "340px", "overflow":"auto"}}>
                                    <table className={'table table-sm table-bordered ueColorBase'}>
                                        <thead className={{'fontWeight': 'bold'}}>
                                        <tr>
                                            <th>Loc.</th>
                                            <th>Parcelle mère</th>
                                            <th>parcelle fille</th>
                                            <th>Section</th>
                                            <th>Numéro fille</th>
                                            <th className={'d-none d-md-table-cell'}>Contenance</th>
                                            <th className={'d-none d-md-table-cell'}>Date mutation</th>
                                            <th className={'d-none d-md-table-cell'}>N°Dnupro</th>
                                            <th className={'d-none d-md-table-cell'}>Lieu</th>
                                            <th className={'d-none d-md-table-cell'}>Commune</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            (props.histoParcelles)
                                                ? props.histoParcelles.map((item, index) => {
                                                    return renderItem(item, index)
                                                })
                                                : null
                                        }
                                        </tbody>

                                    </table>
                                </div>
                            </Fragment>
                            :<div className="d-flex justify-content-between mb-1">
                                <h5 className={"ueColorBase d-inline-flex mr-3"}>{title}</h5>
                                <button className={'btn btn-primary btn-sm'} onClick={(e)=>setDisplayMe(true)}>
                                <i className="fas fa-caret-down"></i> Afficher</button>
                            </div>
                        }
                    </div>
                </div>
                :null
            }
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        displayHistoriqueList : state.SearchReducer.displayHistoriqueList,
        histoParcelles: state.SearchReducer.histoParcelles,
        refMap: state.MapReducer.refMap,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        setDisplayHistoriqueList : (e)=>dispatch({type: 'DISPLAY_HISTORIQUE_LIST_PARCELLES',data: {displayHistoriqueList: e}} ),
        cleanVectorLayer: (e)=>dispatch({type: 'CLEAR_VECTOR_LAYER', data: e}),
        setShowSearchPanel: (e) => dispatch( {type: 'SHOW_SEARCH_PANEL', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(HistoriqueListParcelles);
